/* @flow */
import * as React from 'react';

import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import styles from './ElectroCheckRadioGroup.module.scss';

type CheckRadioGroupProps = {
  field: Object,
  /** Array containing the `name` for UI displaying
   *  and the `id` to add to the `field` value */
  options: {
    id: string,
    name: string,
  }[],
  /** This will be the label for the checkbox */
  title: string,
};

/** Displays a `Checkbox` to enable and disable a `Radio` group of an `options` array of { id, name } objects,
 * using a given `field` that will use a `string` `Array` as value.
 */
class ElectroCheckRadioGroup extends React.Component<CheckRadioGroupProps> {
  get isDisabled() {
    const { field, options } = this.props;
    if (!Array.isArray(field.value)) return true;
    return !options.some(option => field.value.includes(option.id));
  }

  handleCheckboxToggle = () => {
    const { field, options } = this.props;
    let currentValue = Array.isArray(field.value) ? [...field.value] : [];

    if (this.isDisabled) {
      currentValue.push(options[0].id);
      currentValue = Array.from(new Set(currentValue));
    } else {
      currentValue = currentValue.filter(id => !options.some(option => option.id === id));
    }
    field.set(currentValue);
  };

  setSelected = (selectedId: string) => {
    const { field, options } = this.props;

    let currentValue = Array.isArray(field.value) ? [...field.value] : [];

    currentValue = currentValue.filter(id => !options.some(option => option.id === id));
    currentValue.push(selectedId);

    field.set(currentValue);
  };

  render() {
    const { options, title, field } = this.props;
    const selectedId = Array.isArray(field.value)
      ? field.value.find(id => options.some(option => option.id === id)) || ''
      : '';

    return (
      <div className={styles['check-and-radio-container']}>
        <FormControl>
          {/* Checkbox control for enabling and disabling */}
          <FormControlLabel
            className={styles['checkbox-label']}
            label={title}
            control={<Checkbox checked={!this.isDisabled} onChange={this.handleCheckboxToggle} />}
          />
          {/* Radio group control mapping each option */}
          <FormGroup className={styles['radio-group']}>
            {options.map(option => {
              const isSelected = option.id === selectedId;
              return (
                <FormControlLabel
                  className={styles['radio-label']}
                  key={option.id}
                  disabled={this.isDisabled}
                  value={option.id}
                  label={option.name}
                  control={<Radio checked={isSelected} />}
                  onChange={() => this.setSelected(option.id)}
                />
              );
            })}
          </FormGroup>
        </FormControl>
      </div>
    );
  }
}

export default ElectroCheckRadioGroup;
